import React, { useEffect, useState } from "react";
import { Link,useParams,useNavigate } from "react-router-dom";
import { StateUseContext } from "../context/UserDetailContext";
import UserDetail from "../components/StudentBankDetail/UserDetail";
import BankDetailForm from "../components/StudentBankDetail/BankDetailForm";
import { getCashWinnerBankDetailStatus } from "../actions/StudentAction";


const StudentBankDetail = () => {
    const { userDetail } = StateUseContext();
    const [showForm,setShowForm] = useState();
    const [loading,setLoading] = useState();
    const [winnerBankDetail,setWinnerBankDetail] = useState({});
    const params = useParams();
    const navigate = useNavigate();

    const { name, form_num, father_name,id } = userDetail || {};
  
  useEffect(()=> {
    if(+params?.id !== id){
      navigate('/student/dashboard')
    }
  },[params,id])
  

  useEffect(() => {

    const checkCashWinnerEligibleStatus = async () => {
      try {
        setLoading(true)
        await getCashWinnerBankDetailStatus(form_num).then((res) => {
            if(res.status){
              if(res.student_id ===id){
                setLoading(false)
                setShowForm(true)
              }
            }
            else if(res.status === false && res.prize_distribution ===1){
                setLoading(false)
                setShowForm(false)
                setWinnerBankDetail(res?.prize_winner)
            }
            else{
              navigate('/student/dashboard')
            }
        });
      } catch (error) {
        setLoading(false)
        console.log(error);
      }
    };

    checkCashWinnerEligibleStatus()
  }, []);


  return (
    <div className="container mt-5 referral">
      <div className="row align-items-center">
        <div className="col-6">
          <h2 className="fs-6 fs-lg-4 fs-md-5 fw-bold my-0">
            Student bank detail
          </h2>
        </div>
        <div className="col-6 text-end">
          <Link
            to={"/student/dashboard"}
            className="go-to-dashLink text-secondary px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none"
          >
            Go To Dashboard
          </Link>
        </div>
      </div>

      <div className="alert alert-warning mt-4 fw-bold" role="alert">
        <b>NOTE</b> : Please fill the details to receive your cash reward. In
        case of any queries, write to us at{" "}
        <a href="mailto:support.overseas@allen.in" className="text-lowercase">support.overseas@allen.in</a> or
        contact your respective country representative.
      </div>

      <div className="card bg-secondary-light cash_winnerDetail p-4">
        <UserDetail name={name} form_num={form_num} father_name={father_name} />
      </div>
        {loading ? (
            <div className="text-center py-5">
                <div className="spinner-grow spinner-grow-sm mt-2" role="status">
                        <span  className='visually-hidden'>Loading...</span> 
                </div> <span className='d-block fw-bold fs-6 mt-1 ms-2'>Verifying eligibility status...</span>
            </div>
        ):(
            <>
             {showForm ? (
                    <div className="card p-4 mt-4 mb-5">
                        <BankDetailForm userDetail={userDetail !== undefined && userDetail} />
                    </div>
                ) : (
                    <div className='bank-detail-submitted mt-4 mb-5'>
                        <h5 className='text-success fw-bold mb-4'>You have successfully submitted bank details.</h5>
                        <div className="row">
                          <div className="col-lg-12">
                            <h6 className="text-black fw-bold pb-2 border-bottom">Uploaded Documents </h6>
                          </div>
                          <div className="row">
                            <div className="col-12 col-md-6 col-lg-4">
                              <span>Latest Marksheet (Current Grade)</span>
                              <h4>{winnerBankDetail?.marksheet}</h4>
                            </div>
                            <div className="col-12 col-md-6  col-lg-4">
                              <span>Student Passport Copy</span>
                              <h4>{winnerBankDetail?.student_passport}</h4>
                            </div>
                            <div className="col-12 col-md-6  col-lg-4">
                              <span>Parent Passport Copy</span>
                              <h4>{winnerBankDetail?.parent_passport}</h4>
                            </div>
                          </div>
                        </div>
                        
                        <div className="row g-3">
                          <div className="col-lg-12 mt-5">
                            <h6 className="text-black pb-2 border-bottom fw-bold">
                              Beneficiary Bank Details
                            </h6>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Bank Country</span>
                            <h4>{winnerBankDetail?.beneficiary_bank_country}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Bank Account Holder Type</span>
                            <h4>{winnerBankDetail?.bank_holder_type}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Parent Name</span>
                            <h4>{winnerBankDetail?.parent_name ?? "—"}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Name</span>
                            <h4>{winnerBankDetail?.beneficiary_name}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Account Number / IBAN</span>
                            <h4>{winnerBankDetail?.beneficiary_account_no_iban}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Swift Code</span>
                            <h4>{winnerBankDetail?.beneficiary_bank_swift_code}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Bank Name</span>
                            <h4>{winnerBankDetail?.beneficiary_bank_name}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Bank Location</span>
                            <h4>{winnerBankDetail?.beneficiary_bank_location}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Mob. Registered with bank account</span>
                            <h4>{winnerBankDetail?.registered_bank_mob_no}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Address Line 1</span>
                            <h4>{winnerBankDetail?.beneficiary_addr_line1 ?? "—"}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Address Line 2</span>
                            <h4>{winnerBankDetail?.beneficiary_addr_line2 ?? "—"}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Address Line 3</span>
                            <h4>{winnerBankDetail?.beneficiary_addr_line3 ?? "—"}</h4>
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <span>Beneficiary Bank Address</span>
                            <h4>{winnerBankDetail?.beneficiary_bank_address}</h4>
                          </div>
                        </div>
                    </div>
                )
             }
            </>
        )}
       
      

    </div>
  );
};

export default StudentBankDetail;
